import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

import { NonDatasourceFieldDetailsFragmentGql } from './NonDatasourceFieldDetailsFragmentGql';
import { SheetFieldInstanceDatasourceFragmentGql } from './SheetFieldInstanceDatasourceFragmentGql';

export const SheetFieldInstanceFragmentGql: DocumentNode = gql`
fragment SheetFieldInstanceFragment on Field {
  __typename
  id
  name
  description
  ...NonDatasourceFieldDetailsFragment
  datasource {
    ...SheetFieldInstanceDatasourceFragment
  }
  ... on DatasourceField {
    datasourceField: id
    remoteField {
      datasource {
        ...SheetFieldInstanceDatasourceFragment
      }
      ...NonDatasourceFieldDetailsFragment
      referencedByFlowFieldOutputField {
        parentFields {
          ... on FlowColumnInputField {
            column {
              id
              name
              description
              table {
                id
                name
              }
            }
          }
        }
      }
    }
  }
  upstreamDatabasesConnection {
    nodes {
      id
      name
      connectionType
      isCertified
    }
  }
}
${SheetFieldInstanceDatasourceFragmentGql}
${NonDatasourceFieldDetailsFragmentGql}
`;
